import { PendingRequestsByAuthorizer } from '../../../../models/requests-management/pendingRequest';
import { RequestModel } from '../../../../models/requests-management/requests';
import { GetSchedulingsChangeRequestsHistoryRequest } from '../../../../pages/request-management/components/modals/RequestHistoryModal';
import { requests } from '../apiAgent';

export const RequestsManagementsAPI = {
    createSchedulingChangeRequests: (body: any) => {
        return requests
            .postFormData('/jerusalem/api/v2.0.0/scheduling-change-requests', body)
            .then((response) => response)
            .catch((err) => err);
    },

    getPendingRequestsByUser: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/pending-scheduling-change-requests-by-user'
            )
            .then((response) => response);
    },

    getWorkshiftSchedulingAndInterruptionsByUser: (data: {
        startDate: string;
        endDate: string;
    }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/workshift-scheduling-and-interruptions-by-user',
                data
            )
            .then((response) => response);
    },

    getHistoryByEmployee: (data: {
        startDate: string;
        endDate: string;
        status: number | null;
    }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/schedulings-change-requests-history-by-employee',
                data
            )
            .then((response) => response);
    },

    getRequestsPendingRequestsByAuthorizer: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/pending-requests-by-authorizer'
            )
            .then((response: PendingRequestsByAuthorizer) => response);
    },

    getSchedulingChangeRequestById: (id: number) => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/get-scheduling-change-request-by-id/' +
                    id
            )
            .then((response) => response);
    },

    getInterruptionRequestById: (id: number) => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/get-interruption-request-by-id/' +
                    id
            )
            .then((response) => response);
    },

    abortSchedulingChangeRequest: (id: number) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/' + id + '/abort',
                id
            )
            .then((response) => response);
    },

    abortInterruptionRequest: (id: number) => {
        return requests
            .put('/jerusalem/api/v2.0.0/interruption-requests/' + id + '/abort', id)
            .then((response) => response);
    },

    approvedSchedulingChangeRequest: (body: RequestModel) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/approve-scheduling-change-request',
                body
            )
            .then((response) => response);
    },

    rejectSchedulingChangeRequest: (body: RequestModel) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/reject-scheduling-change-request',
                body
            )
            .then((response) => response)
            .catch((e) => e);
    },

    getSchedulingChangeRequestByAuthorizersFiltered: (
        body: GetSchedulingsChangeRequestsHistoryRequest
    ) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/schedulings-change-requests-history-by-authorizer',
                body
            )
            .then((response) => response)
            .catch((e) => e);
    },
};
